var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVersatileDataCapacityIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_108",
    "data-name": "Group 108",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 138.995,
    height: 140.632,
    viewBox: "0 0 138.995 140.632",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_130",
    "data-name": "Rectangle 130",
    width: 138.995,
    height: 140.632,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_107",
    "data-name": "Group 107",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_148",
    "data-name": "Path 148",
    d: "M69.087.91A68.639,68.639,0,1,1,.487,69.551,68.617,68.617,0,0,1,69.087.91",
    transform: "translate(1.308 2.443)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_149",
    "data-name": "Path 149",
    d: "M68.6,0A68.639,68.639,0,1,1,0,68.638,68.616,68.616,0,0,1,68.6,0",
    transform: "translate(0 0)",
    fill: "#1a1818",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_150",
    "data-name": "Path 150",
    d: "M84.832,29.5a10.259,10.259,0,0,0-5.712-11.11,11.282,11.282,0,0,0-3.261-1.08c-1.776-.3-.719.214-2.281-1.9a12.483,12.483,0,0,0-4.65-3.729c-2.731-1.161-4.326-1.047-7.488-1.047-5.015,0-39.968-.2-42.459.066A12.022,12.022,0,0,0,9.27,17.89C7.715,21.435,8.312,29.571,8.312,34V50.919c0,5.981-.663,10.37,2.58,14.49a12.525,12.525,0,0,0,4.883,3.652c2.532,1.043,4.58.877,7.5.877H57.249c6.769,0,9.216.579,14.618-2.443a16.5,16.5,0,0,0,7.525-9.4c.527-1.89,2.255-11.645,2.745-14.313.873-4.713,2-9.585,2.694-14.276M23.623,23.03c-3.534.641-3.04,3.969-3.04,6.327,0,2.285-.269,7.26.066,9.235.6,3.534,4.393,2.966,6.368,2.966,2.233,0,7.377.273,9.272-.059a3.536,3.536,0,0,0,2.583-2.086c.575-1.234.416-12.68.225-13.613-.678-3.339-4.182-2.849-6.39-2.849s-7.241-.258-9.084.077M22.455,50.3c-1.728.4-2.336,1.876-1.931,3.965.383,1.979,1.971,1.968,4.1,1.968,2.638,0,35.619.144,36.555-.052,1.684-.354,2.152-2.123,1.839-4-.38-2.255-2.775-1.938-4.124-1.938-2.554,0-35.594-.14-36.438.059M44.938,23.141c-1.725.4-2.443,2.484-1.754,4.422s2.841,1.529,5.085,1.529c1.813,0,12.109.129,12.979-.077,2.167-.516,2.045-3.394,1.655-4.415-.726-1.894-2.93-1.533-5.056-1.533-1.806,0-12.035-.125-12.909.074m.029,12.588c-1.758.38-2.473,2.491-1.791,4.418.693,1.953,2.955,1.526,5.093,1.526,1.813,0,12.138.125,12.993-.063,1.618-.346,2.322-2.679,1.636-4.429-.722-1.835-2.963-1.5-5.052-1.5-1.717,0-12.127-.118-12.879.044M14.367,58.7c-.21-1.68-.07-23.455-.07-25.755,0-2.69-.321-10.532.42-12.459,1.662-4.323,5.811-3.829,9.01-3.829H62.338c2.163,0,3.766.085,5.233,1.168a6.134,6.134,0,0,1,2.373,4.061c.2,1.621.063,23.485.063,25.733,0,2.874.376,10.244-.439,12.481-1.574,4.345-6,3.8-9.028,3.8H21.928c-2.126,0-3.8-.1-5.222-1.176a6.134,6.134,0,0,1-2.34-4.028",
    transform: "translate(22.016 28.365)",
    fill: "#fff",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVersatileDataCapacityIcon);
export default __webpack_public_path__ + "static/media/versatile-data-capacity-icon.9ceb3b10bcb3997c51b922db170f52df.svg";
export { ForwardRef as ReactComponent };